'use client';

import Link from 'next/link';
import { Video } from '@/app/elements/video/video';
import { classes } from '@/utils/classes/classes';

import './styles/@theme';
import { type LauncherUrlProps } from '@/utils/url/launcher-url';
import { GameUrl } from '@/app/components/game/subcomponents/game-url/game-url';
import { RemindMeButton } from '@/app/components/remind-me-button';
import { REMINDER_MODULES } from '@/tracking/amplitude/events/general/reminder';
import { useShowRemindMe } from '@/hooks/use-show-remind-me';

type TrailerSectionProps = {
    isPostLaunch: boolean;
    isPreLaunch: boolean;
    videoTrailerUrl?: string;
    gameUid: string;
    contentId: string;
    videoPoster?: string;
    ctaText: string;
    categoryPath: string;
    onCtaClick: () => void;
    launcherUrlProps: LauncherUrlProps;
    playNowButtonText: string;
    zoneUid: string;
    isEarlyAccess: boolean;
};

export const TrailerSection: React.FC<TrailerSectionProps> = ({
    isPostLaunch,
    isPreLaunch,
    videoTrailerUrl,
    gameUid,
    contentId,
    videoPoster,
    ctaText,
    categoryPath,
    onCtaClick,
    launcherUrlProps,
    playNowButtonText,
    zoneUid,
    isEarlyAccess
}) => {
    const isRemindMeEnabled = useShowRemindMe();
    const showRemindMe = isPreLaunch && isRemindMeEnabled;

    return (
        <div className="column">
            {videoTrailerUrl && (
                <Video
                    uid={gameUid}
                    src={videoTrailerUrl}
                    videoId={contentId}
                    poster={videoPoster}
                    inPopup={true}
                    disableGameLauncher={true}
                    hasVideoDetails={false}
                />
            )}

            <div className="cta-wrapper">
                {isPostLaunch ? (
                    <GameUrl launcherUrlProps={launcherUrlProps}>
                        <div
                            className={classes(
                                'navigate-button',
                                'navigate-button--post-launch',
                                isEarlyAccess && 'navigate-button--early-access'
                            )}
                            onClick={onCtaClick}>
                            {playNowButtonText}
                        </div>
                    </GameUrl>
                ) : (
                    <Link
                        href={categoryPath}
                        className={classes('navigate-button', showRemindMe && 'navigate-button--outline')}
                        onClick={onCtaClick}
                        prefetch={false}>
                        {ctaText}
                    </Link>
                )}

                {showRemindMe && (
                    <RemindMeButton
                        zoneUid={zoneUid}
                        gameId={gameUid}
                        module={REMINDER_MODULES.PRE_LAUNCH_POP_UP}
                        gameName={launcherUrlProps.gameName || ''}
                    />
                )}
            </div>
        </div>
    );
};
